<template>
  <section
    :class="[
      'logo-wrap',
      isCollapse ? 'logo-wrap-collapse':'',
      isCollapse && layout !== 'mix' ? 'center' : '',
      `logo-wrap__${layout}`
    ]"
  >
    <router-link
      v-if="!isCollapse || layout === 'top'"
      to="/"
      :class="[
        'logo-content',
        layout === 'mix' ? 'logo-content__mix' : ''
      ]"
    >
      <img
        src="~@/assets/images/logo-bi.png"
        :class="['sidebar-logo', $route.meta.hideAside || layout !== 'side' ? '' : '']"
      />
       <span class="maia-system-title">一站式分析平台</span>
    </router-link>

    <section
      id="asideCollapse"
      v-if="!$route.meta.hideAside && layout !== 'top'"
      :class="{collapse:true,isLogoCollapse:isCollapse}"
    >
      <div v-if="isCollapse" class="logo-img">
        <img
             src="~@/assets/images/logo-bi.png"
             :class="['sidebar-logo',]"
        />
      </div>
      <span
        v-if="isCollapse"
        :class="['collapse-btn', 'open', layout === 'mix' ? 'mix' : '']"
        @click="collapseToggle(false)"
      >
        <svg-icon
          icon-class="btn-collapse"
          class-name="btn"
        />
      </span>
      <span
        v-else
        class="collapse-btn"
        @click="collapseToggle(true)"
      >
        <svg-icon
          icon-class="btn-collapse"
          class-name="btn"
        />
      </span>
    </section>
  </section>
</template>
<script lang="ts">
  import { defineComponent, computed } from 'vue';
  import { useStore } from 'vuex';
  import { SET_COLLAPSE_STATUS } from '@/store/actionTypes';

  export default defineComponent({
    name: 'logo',
    props: {
      isCollapse: {
        type: Boolean,
        default: false,
      },
    },
    setup() {
      const { getters, commit } = useStore();
      // // 初始化默认值为收起
      // commit(`app/${SET_COLLAPSE_STATUS}`, true);
      const layout = computed(() => getters.layout);
      return {
        layout,
        collapseToggle: (value: boolean) => {
          commit(`app/${SET_COLLAPSE_STATUS}`, value);
        },
      };
    },
  });
</script>

<style lang="scss" scoped>
  .logo-wrap {
    @include flex-box();

    box-sizing: border-box;
    //height: $--header-height;
    height: 48px;
    //padding-right: 10px;

    .logo-content {
      display: flex;
      align-items: center;
    }

    .sidebar-logo {
      width: 19px;
      height: 19px;
      margin-right: 4px;
      margin-left: 18px;

      &.ml-4 {
        margin-left: 4px;
      }
    }

    &.center {
      justify-content: center;
      padding-right: 0;
    }

    &.logo-wrap__mix {
      margin-right: 12px;
    }
  }
  .logo-wrap-collapse{
    height: 80px;
  }
  .collapse {
    .collapse-btn {
      height: $--btn-hover-height;
      //padding: 4px 6px;
      padding-right: 6px;
      font-size: 20px;
      cursor: pointer;

      &.open {
        &:not(.mix) {
          margin-right: 0;
        }

        .btn {
          transform: rotate(180deg);
        }
      }
    }
  }
  .isLogoCollapse{
    height: 80px;
    width: 100%;
    //display: flex;
    //justify-content: center;
    //flex-wrap: wrap;
    .logo-img{
      width: 100%;
      height: 20px;
      margin: 12px 0;
      text-align: center;
      img{
        width: 20px;
        height: 20px;
        margin-right: 0 !important;
        margin-left: 2px !important;
      }
    }

    .collapse-btn{
      display: inline-block;
      width: 100%;
      height: 20px;
      padding-right: 0;
      text-align: center;
    }
  }
</style>
